import { Grid } from '@mui/material';
import { type ColumnResizeDirection } from '@tanstack/react-table';

import { resizerStyles } from './styles';

interface ColumnResizerProps {
  deltaOffset: number;
  isLast: boolean;
  resizeDirection: ColumnResizeDirection;
  onGetIsResizing: () => boolean;
  onGetResizeHandler: (context?: Document) => (event: unknown) => void;
  onResetSize: () => void;
}

const ColumnResizer: React.FC<React.PropsWithChildren<ColumnResizerProps>> = ({
  isLast,
  resizeDirection,
  onGetIsResizing,
  onGetResizeHandler,
  onResetSize,
}) => {
  return (
    <Grid
      className={`${resizerStyles().className} ${resizeDirection} ${onGetIsResizing() ? 'isResizing' : ''}`}
      style={{
        left: isLast ? 10 : 23,
      }}
      onDoubleClick={() => onResetSize()}
      onMouseDown={onGetResizeHandler()}
      onTouchStart={onGetResizeHandler()}
    />
  );
};

export default ColumnResizer;
